import axios from "axios";
import HttpService from "./HttpService.js";

export default class UserService {
    constructor() {
        this._http = new HttpService();
        this._urlBase = `${process.env.REACT_APP_DELIVERIES_API}/users`;
    }

    async registerUser(data) {
        const response = await this._http.post(this._urlBase, data);
        return response;
    }

    async getUser(id) {
        const response = await this._http.get(`${this._urlBase}/id/${id}`);
        return response;
    }

    async getByDocument(document) {
        const response = await this._http.get(`${this._urlBase}/get_by_document/${document}`);
        return response;
    }

    async refreshUser(id) {
        const response = await this._http.get(`${this._urlBase}/refresh/${id}`);
        return response;
    }

    async updateUser(id, data) {
        const response = await this._http.put(`${this._urlBase}/id/${id}`, data);
        return response;
    }

    async getStoresWithInServiceRadius(id) {
        const response = await this._http.get(`${this._urlBase}/get_store_with_in_service_radius/${id}`);
        return response;
    }

    async getMyLicensedConnections(id, page) {
        const queryParams = new URLSearchParams();
        if (page) queryParams.append('page', page.toString());
        const response = await axios.get(`${this._urlBase}/get_my_licensed_connections/${id}?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    }

    async requestLicensedConnection(id, storeId) {
        const response = await this._http.post(`${this._urlBase}/request_licensed_connection/${id}/${storeId}`);
        return response;
    }

    async updateLicensedConnection(connectionId, status) {
        const response = await this._http.put(`${this._urlBase}/update_licensed_connection/${connectionId}`, {
            "status": status
        });
        return response;
    }

    async destroyLicensedConnection(connectionId) {
        const response = await this._http.delete(`${this._urlBase}/licensed_connection/${connectionId}`);
        return response;
    }

    async updateLicensedFees(id, licensedFee, serviceRadius) {
        const response = await this._http.put(`${this._urlBase}/update_licensed_fees/${id}`, {
            "serviceRadius": serviceRadius,
            "licensedFee": licensedFee
        });
        return response;
    }
}
